import * as React from "react";
import "./_remoteRequest.scss";

const RemoteWorkProgressBar = ({ usedDays, totalDays, isLimitReached = false }) => {
  const [style, setStyle] = React.useState({});

  // Update style whenever usedDays or totalDays changes
  React.useEffect(() => {
    // If used days is 0, show empty progress bar
    if (usedDays === 0) {
      const newStyle = {
        opacity: 1,
        width: '0%',
        max_width: '0%',
      };
      setStyle(newStyle);
      return;
    }
    
    // If limit is exceeded (usedDays > totalDays), show full progress bar
    if (usedDays > totalDays) {
      const newStyle = {
        opacity: 1,
        width: '100%',
        max_width: '100%',
      };
      setStyle(newStyle);
      return;
    }
    
    // Normal progress calculation
    const safeTotal = totalDays || 1;
    const percentage = (usedDays * 100) / safeTotal;
    
    const newStyle = {
      opacity: 1,
      width: `${percentage}%`,
      max_width: `${percentage}%`,
    };
    setStyle(newStyle);
  }, [usedDays, totalDays]);
  
  // Check if progress is complete (limit reached or exceeded)
  const isComplete = usedDays >= totalDays || isLimitReached;
  
  // Check if progress bar should be empty (gray)
  const isEmpty = usedDays === 0;
  
  return (
    <>
      <div className="progress">
        <div 
          className={`progress-done ${isComplete ? 'progress-complete' : ''}`} 
          style={style}
        >
          {!isEmpty && (
            <span>
              {`${usedDays} days`}
            </span>
          )}
        </div>
      </div>
      <div className="progress_bar_values">
        <div>
          <span>0 days</span>
        </div>
        <div>
          <span>10 days</span>
        </div>
      </div>
      {isComplete && (
        <div style={{ 
          fontSize: '12px', 
          color: '#ff6b6b', 
          marginTop: '5px',
          fontWeight: 'bold'
        }}>
          {usedDays > 10 ? (
            `Remote work limit exceeded! (${usedDays} days used, ${usedDays - 10} days over limit)`
          ) : (
            `Remote work limit reached! (${usedDays} / 10 days used)`
          )}
        </div>
      )}
    </>
  );
};

export default RemoteWorkProgressBar;